export const ResultsContextDefaultData = {
	total_results: null,
	total_pages: null,
    current_page: 1,
    results: [],
}